import {
  getProcurementActionLabel,
  getProcurementActionsForStatus,
} from "./procurementOrderActionConfig";

export default function ProcurementOrderProcessingActions({
  status,
  disabled = false,
  onAction,
}) {
  const actions = getProcurementActionsForStatus(status);
  if (actions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {actions.map((actionKey) => (
        <button
          key={actionKey}
          type="button"
          disabled={disabled}
          onClick={() => onAction?.(actionKey)}
          className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 disabled:opacity-60"
        >
          {getProcurementActionLabel(actionKey)}
        </button>
      ))}
    </div>
  );
}
